import { Cluster } from 'frontend/clusters'
import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'
import { StagingArea } from 'frontend/staging-areas'
import { markRaw } from 'vue'

export const StagingAreaCalendarEntryDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'eid',
    'start_at',
    'end_at',
    'kind',
    'updated_at',
    'created_at',
    {
      staging_area: [
        'id',
        'name',
        'has_minimum_vehicles_allotment',
        'has_subfleet',
        'has_welcome_desk',
        'time_zone',
        { locations: ['id', 'name'] },
        { clusters: ['id', 'name'] },
      ],
    },
  ],
  subscriptions: {
    items: 'CalendarEntriesWelcomeDeskWorkingHoursChannel',
    stagingAreas: 'StagingAreasSimpleChannel',
  },
  defaultColumns: ['eid', 'stagingArea', 'locations', 'startAt', 'endAt'],
  columnConfig: {
    eid: {
      label: 'EID',
      header: {
        sort: 'eid',
      },
      cell: {
        kind: 'simple',
        path: 'eid',
      },
    },
    stagingArea: {
      label: 'Staging Area',
      cell: {
        kind: 'component',
        component: markRaw(StagingArea),
        componentProps: entry => ({ stagingArea: entry.stagingArea }),
      },
    },
    locations: {
      label: 'Locations',
      cell: {
        kind: 'component',
        component: 'limited-components-list',
        componentProps: item => ({
          items: item.stagingArea?.locations,
          limit: 5,
          component: markRaw(Location),
          componentProps: location => ({
            location,
            minWidth: 250,
          }),
        }),
      },
    },
    clusters: {
      label: 'Clusters',
      cell: {
        kind: 'component',
        component: 'limited-components-list',
        componentProps: item => ({
          items: item.stagingArea?.clusters,
          limit: 5,
          component: markRaw(Cluster),
          componentProps: cluster => ({
            cluster,
          }),
        }),
      },
    },
    startAt: {
      label: 'Start Datetime',
      header: {
        sort: 'startAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({ t: item?.startAt, tz: item.stagingArea?.timeZone }),
      },
    },
    startTime: {
      label: 'Start Time',
      header: {
        sort: 'startAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item?.startAt,
          tz: item.stagingArea?.timeZone,
          format: 'timeOnly',
        }),
      },
    },
    startDate: {
      label: 'Start Date',
      header: {
        sort: 'startAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item?.startAt,
          tz: item.stagingArea?.timeZone,
          format: 'dateOnly',
        }),
      },
    },
    endAt: {
      label: 'End Datetime',
      header: {
        sort: 'endAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({ t: item?.endAt, tz: item.stagingArea?.timeZone }),
      },
    },
    endTime: {
      label: 'End Time',
      header: {
        sort: 'endAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item?.endAt,
          tz: item.stagingArea?.timeZone,
          format: 'timeOnly',
        }),
      },
    },
    endDate: {
      label: 'End Date',
      header: {
        sort: 'endAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item?.endAt,
          tz: item.stagingArea?.timeZone,
          format: 'dateOnly',
        }),
      },
    },
    createdDatetime: {
      label: 'Created Datetime',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: entry => ({
          t: entry.createdAt,
        }),
      },
    },
    createdDate: {
      label: 'Created Date',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: entry => ({
          t: entry.createdAt,
          format: 'dateOnly',
        }),
      },
    },
    createdTime: {
      label: 'Created Time',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: entry => ({
          t: entry.createdAt,
          format: 'timeOnly',
        }),
      },
    },
    updatedDatetime: {
      label: 'Updated Datetime',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: entry => ({
          t: entry.updatedAt,
        }),
      },
    },
    updatedDate: {
      label: 'Updated Date',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: entry => ({
          t: entry.updatedAt,
          format: 'dateOnly',
        }),
      },
    },
    updatedTime: {
      label: 'Updated Time',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: entry => ({
          t: entry.updatedAt,
          format: 'timeOnly',
        }),
      },
    },
  },
}
